import styled from 'styled-components';
import { Drawer as AnteDrawer } from 'antd';
import { breakpoints } from 'config/config';

export const StyledDrawerTitleWrapper = styled('div')`
  display: flex;
  gap: 30px;

  .title {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 5px;
    font-size: 14px;

    .title-action {
      white-space: nowrap;
    }

    label {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
    }
  }

  .transaction-type {
    margin: 0;
    line-height: 22px;
    height: fit-content;
    border-radius: 30px;
    border-color: ${(props) => props.theme.wholesale};
    color: ${(props) => props.theme.black};
  }
`;

export const StyledDrawerTitle = styled('div')`
  .ant-form-item {
    margin-bottom: 0;
    margin-top: 20px;
    .ant-form-item-row {
      min-width: 100px;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .title {
      margin-bottom: 0;
    }

    .ant-form {
      width: 94vw;
      .ant-flex {
        display: flex;
        flex-wrap: wrap;
        gap: 5px !important;
        .ant-form-item {
          margin-top: 5px;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-form {
      width: 93vw;
    }
  }

  @media only screen and (max-width: 440px) {
    .ant-form {
      width: 92vw;
    }
  }
`;

export const StyledDrawer = styled(AnteDrawer)`
  .banner-drawer-url-warning {
    font-size: 14px;
    color: ${(props) => props.theme.textColor};
    margin-top: 0;
    opacity: 0.7;
  }

  .ant-input-affix-wrapper {
    font-size: 14px;
  }

  .delivery-price-input {
    width: 100%;
  }

  .ant-drawer-body {
    padding: 12px 40px;
  }

  .delivery-drawer-create-address {
    .ant-form-item-additional {
      width: 100.5% !important;
      top: -1px !important;
      left: -1px !important;
      height: 43px !important;
    }
  }

  .label-wrapper {
    border-top: 1px solid ${(props) => props.theme.silverGray};
    width: 100%;

    h4 {
      font-weight: 400;
      font-size: 16px;
      font-family: ${(props) => props.theme.fontFamily};
      color: ${(props) => props.theme.black};
    }
  }

  .product-count-wrapper {
    position: relative;
    padding-bottom: 24px;

    .productCount {
      display: flex;
      position: relative;
      align-items: center;
      gap: 15px;

      h1 {
        margin: 0;
      }
    }
  }

  .ant-select-arrow,
  .anticon {
    color: ${(props) => props.theme.black};
  }

  .ant-select-item-option-content,
  .ant-select-selection-item {
    font-size: 16px;
  }
  .address-finder {
    min-width: 35px;
    margin-bottom: 24px;

    .data-grid {
      position: relative;
      z-index: 15;
      background-color: ${(props) => props.theme.white};
      border: 1px solid ${(props) => props.theme.silverGray};
      border-top: 0;
      border-bottom: 0;
    }
    .ant-form-item {
      margin: 0;
      max-height: 35px;
    }

    .ant-form-item-additional {
      position: absolute;
      border: 1px solid ${(props) => props.theme.red};
      top: 0;
      width: 787px;
      height: 42px;
      .ant-form-item-explain-error {
        position: absolute;
        top: 39px;
      }
    }
  }

  .label {
    font-size: 14px;
    color: ${(props) => props.theme.colorPrimary};
    padding-bottom: 4px;
  }

  .ant-tabs-nav-list {
    cursor: default;
  }

  .ant-tabs-nav::before {
    border-bottom: solid 1px ${(props) => props.theme.addProductUnderline};
  }

  .unit-value {
    display: flex;
    flex-direction: row;
  }

  .ant-drawer-header {
    min-height: 113px;
  }

  .ant-drawer-header-title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;

    .ant-drawer-close {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 22px;
      width: 22px;

      svg {
        width: 22px;
        height: 22px;
        color: ${(props) => props.theme.black} !important;
      }
    }

    .ant-drawer-title {
      max-width: 300px;
      text-decoration: none;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .ant-drawer-body {
    .preview {
      display: flex;
      flex-wrap: wrap;
      width: auto;
      height: 800px;
    }
  }

  .ant-col {
    padding-bottom: 0;
  }

  .ant-drawer-footer {
    border-top: 0;
    .btns {
      display: flex;
      justify-content: right;
      gap: 10px;

      .ant-btn {
        border-radius: 3px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-header {
      min-height: fit-content;
      padding: 16px;
    }

    hide-mobile {
      display: none;
    }

    .ant-drawer-header-title {
      .ant-drawer-title {
        font-size: 1rem;
      }
    }

    .ant-drawer-body {
      padding: 16px;
    }

    .ant-drawer-footer .btns {
      overflow-x: auto;
      flex-wrap: nowrap;
      -webkit-overflow-scrolling: touch;
      justify-content: flex-start;

      &::-webkit-scrollbar {
        height: 4px;
      }

      &::before {
        content: '';
        margin-left: auto;
      }

      > * {
        flex: 0 0 auto;
      }
    }

    .ant-form-item-label {
      label {
        font-size: 0.875rem !important;
      }
      font-size: 0.875rem;
    }

    .ant-select-item-option-content,
    .ant-select-selection-item {
      font-size: 1rem;
    }

    &.styled-drawer-create-delivery {
      .ant-drawer-body {
        padding: 16px 16px 80px 16px;

        .ant-input {
          border-radius: 3px;
        }

        .ant-form-item {
          margin-bottom: 10px;

          .ant-select {
            .ant-select-selector {
              border-radius: 3px;
            }
          }
        }
      }
    }

    &.create-products-drawer {
      .ant-drawer-body {
        padding: 0;

        .ant-tabs-nav {
          margin-bottom: 0;

          .ant-tabs-nav-list {
            .ant-tabs-tab {
              margin: 0 0 0 20px;
            }

            .ant-tabs-tab:nth-last-child(2) {
              margin: 0 20px 0 20px;
            }
          }
        }

        .ant-tabs-content-holder {
          padding: 16px 16px 80px 16px;

          .ant-form-item {
            margin-bottom: 10px;
          }
        }

        .admin {
          gap: 0;
          .category-selector-item {
            width: 100%;
            .ant-select {
              max-width: 100%;
            }
          }
        }

        .unit-step {
          gap: 0;

          .unit {
            width: 100%;
            .ant-select {
              min-width: 100%;
            }
          }

          .step {
            width: 100%;

            .scnd-tr {
              min-width: 100%;
              .ant-select {
                min-width: 100%;
                .ant-input-number {
                  min-width: 100%;
                }
              }
            }
          }
        }

        .minamount-maxamount {
          gap: 0;

          .available-amount {
            width: 100%;
            .ant-input-number-affix-wrapper {
              min-width: 100%;
            }
          }

          .minamount {
            width: 100%;
            .ant-input-number {
              min-width: 100%;
            }
          }

          .maxamount {
            width: 100%;
            .ant-input-number {
              min-width: 100%;
            }
          }
        }

        .price-discount-time {
          gap: 0;

          .price {
            width: 100%;
            .ant-input-number-affix-wrapper {
              min-width: 100%;
            }
          }

          .discount {
            width: 100%;
            .ant-input-number-affix-wrapper {
              min-width: 100%;
            }
          }

          .time {
            width: 100%;
            .ant-picker {
              min-width: 100%;
            }
          }
        }

        .checkboxes {
          margin-bottom: 10px;

          .ant-checkbox-group {
            display: flex;
            justify-content: space-between;
            width: 100%;
          }
        }

        .prod-availability {
          .min {
            width: 100%;
          }

          .price {
            width: 100%;
          }
          .scnd-tr {
            min-width: 100%;
          }
        }

        .availability {
          .ant-form-item {
            margin-bottom: 30px;
          }
        }

        .prod-availability {
          .title {
            margin-bottom: 15px;
          }
          .min-price {
            gap: 0;
          }
        }

        .additional-info {
          .checkboxes {
            flex-direction: column;
            gap: 10px;
          }
        }

        .ingridients {
          margin-bottom: 30px;
        }

        .macros-wrap {
          .title {
            margin-bottom: 10px;
          }

          .macros {
            gap: 0;
            .kcal {
              width: 100%;
              .ant-input-number {
                width: 100%;
              }
            }
            .fat {
              width: 100%;
              .ant-input-number {
                width: 100%;
              }
            }
          }

          .saturated-fat {
            width: 100%;
            .ant-input-number {
              width: 100%;
            }
          }

          .allergens {
            margin: 30px 0 30px 0;
          }
        }
      }
    }

    .ant-drawer-footer {
      padding: 16px;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    &.create-products-drawer {
      .ant-drawer-body {
        .ant-tabs-content-holder {
          .image-upload {
            .ant-upload-drag {
              width: 100%;
            }

            .ant-upload {
              width: 100%;
              .ant-upload-drag-container {
                width: 100%;
              }
            }

            .custom-upload-list-image-container {
              justify-content: space-between;
            }
          }
        }
      }
    }

    .hide-mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 400px) {
    &.create-products-drawer {
      .ant-drawer-footer {
        padding: 10px;
      }
    }

    .hide-mobile {
      display: none;
    }
  }
`;

export const StyledListingDrawer = styled(StyledDrawer)`
  .status-tag.status,
  .ant-tag.status {
    height: 24px;
    padding: 3px 10px;
    line-height: 18px;
    border-radius: 36px;
    font-size: 12px;
    color: ${({ theme }) => theme.white};
    border: none;
    margin: 0;
  }

  .status-tag.cancelled,
  .ant-tag.cancelled {
    background-color: ${({ theme }) => theme.statusCancelled};
  }

  .ant-drawer-header-title .ant-drawer-title {
    width: 100%;
    max-width: none;

    .anticon {
      color: ${(props) => props.theme.manslauksZils};
    }
  }

  .title {
    display: flex;
    justify-content: space-between;

    .title-cancel {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-right: 14px;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-header-title {
      .title {
        font-size: 1rem;
      }
    }

    .ant-tabs-tab-btn {
      font-size: 1rem;
    }

    .ant-input {
      border-radius: 3px;
    }

    .ant-select-selector {
      border-radius: 3px !important;
    }

    .form-control {
      border-radius: 3px;
      font-size: 1rem;
      height: 30px;
    }

    .ant-input-number {
      border-radius: 3px;
    }

    .ant-picker {
      border-radius: 3px;
    }
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  .add-edit-product-button {
    border-radius: 3px;
  }

  .left {
    margin-right: auto;
  }

  .add-edit-product-button.white {
    border: 1px solid ${(props) => props.theme.darkGrayishBlue};
  }

  .footer-buttons {
    display: flex;
    gap: 10px;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    overflow-x: auto;
    flex-wrap: nowrap;
    justify-content: end;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      height: 4px;
    }

    > .ant-btn {
      flex: 0 0 auto;
      white-space: nowrap;
      padding: 19px 20px !important;
    }

    &:has(.left) {
      flex-direction: column;
      gap: 8px;
      overflow-x: visible;
    }

    .left {
      margin-right: 0;
      text-align: start;
    }

    .footer-buttons,
    .btns {
      display: flex;
      gap: 10px;
      overflow-x: auto;
      flex-wrap: nowrap;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        height: 4px;
      }

      &::before {
        content: '';
        margin-left: auto;
      }

      > * {
        flex: 0 0 auto;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    justify-content: flex-end;

    .btns {
      width: 100%;

      .cancel-button {
        display: none;
      }
    }

    > .ant-btn,
    .btns > .ant-btn {
      padding: 19px 5px !important;
    }
  }
`;

export const StyledMansLauksDrawer = styled(AnteDrawer)`
  .ant-drawer-header {
    min-height: 113px;
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: column;

    > form {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .ant-table-wrapper {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
      }
    }
  }

  /* centre every cell's content both ways: header labels, the product name,
     the selects and the amount inputs line up on one row */
  .ant-table-cell {
    text-align: center;
    vertical-align: middle;
  }

  .ant-form-item {
    max-width: 180px;
    /* drop the default 24px bottom margin so form controls sit level with the
       plain-text cells instead of riding high */
    margin: 0 auto;
  }

  .ant-form-item-explain-error {
    width: 250px;
    font-size: 12px;
  }

  .unit-value {
    display: flex;
    justify-content: center;
    gap: 5px;
  }

  .storage-unit {
    display: flex !important;
    justify-content: center;
    gap: 10px;

    .ant-form-item {
      width: 100px;
    }
  }

  .ant-drawer-footer {
    display: flex;
    justify-content: right;
  }
`;

export const StyledCartDrawerFooter = styled.div`
  font-family: ${(props) => props.theme.fontText};

  .cart-warning-container {
    letter-spacing: 0.5px;
    padding: 14px 16px 14px 16px !important;
    font-weight: 300;
    font-size: 16px;
  }

  .cart-drawer-sum-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    flex-direction: row;
    align-items: center;
    font-size: 24px;

    padding: 32px 0;

    .cart-drawer-sum-title {
      font-weight: 400;

      p {
        margin: 0;
      }
    }

    .cart-drawer-sum {
      font-weight: 700;
    }
  }

  button {
    font-family: ${(props) => props.theme.fontText};
    height: 52px;
    width: 100%;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.1px;
    margin-bottom: 10px;
  }

  &.wholesale {
    button.ant-btn-primary {
      background-color: ${(props) => props.theme.wholesale};
      border-color: ${(props) => props.theme.wholesale};

      &:hover {
        background-color: ${(props) => props.theme.wholesale} !important;
        border-color: ${(props) => props.theme.wholesale} !important;
        opacity: 0.9;
      }
    }
  }
`;
export const StyledDeliveryDrawerFooter = styled.div`
  .delivery-drawer-btn.mobile {
    display: flex;
    flex-direction: row-reverse;
    background-color: transparent;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.darkRed};
    color: ${(props) => props.theme.darkRed};
    font-weight: 500;
  }

  .delivery-drawer-btn {
    display: flex;
    height: 52px;
    width: 100%;
    font-weight: 700;
    font-size: 16px;
  }
`;

export const MobileMenuStyledDrawer = styled(AnteDrawer)`
  .title,
  .text {
    margin: 0;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 10px;
  }

  .count-title {
    font-size: 14px;
    font-weight: 400;

    span {
      font-weight: 600;
    }
  }

  .text {
    font-size: 14px;
    line-height: 14px;

    .bold-text {
      font-weight: 600;
    }
  }

  &.mobile-menu-admin.ant-drawer-content {
    background-color: ${(props) => props.theme.brand01} !important;
    box-shadow: 0px 4px 84px 0px ${(props) => props.theme.halfBlack};
  }

  &.mobile-menu {
    background-color: ${(props) => props.theme.navDark} !important;
    box-shadow: 0px 4px 84px 0px ${(props) => props.theme.halfBlack};
  }

  .ant-menu-item {
    color: ${(props) => props.theme.white} !important;
  }

  .ant-drawer-body {
    padding: 20px;

    .market-type-switch {
      display: flex;
      width: 100%;
      gap: 10px;
      margin-bottom: 12px;

      .market-switch-btn {
        flex: 1;
        height: 40px;
        border: 1px solid ${(props) => props.theme.colorBorder};
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        color: ${(props) => props.theme.white};

        &.emarket {
          background-color: ${(props) => props.theme.brand02};
        }

        &.wholesale {
          background-color: ${(props) => props.theme.wholesale};
        }
      }
    }

    .ant-menu {
      background-color: ${(props) => props.theme.navDark};
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    &.mobile-menu-drawer {
      position: relative;
      margin: 0 !important;
      padding: 0;
      display: block;
    }

    &.mobile-filter {
      padding-bottom: 200px !important;
      box-shadow: 0px 4px 84px 0px ${(props) => props.theme.halfBlack};
      height: 544px !important;
      font-family: ${(props) => props.theme.fontText};

      @media only screen and (max-height: 824px) {
        height: calc(100vh - 119px);
      }

      .ant-select-selection-wrap {
        font-weight: 500;
      }
    }

    &.product-mobile-filter {
      height: 680px !important;

      @media only screen and (max-height: 840px) {
        height: calc(100vh - 199px) !important;
      }
    }

    &.mobile-menu-admin {
      padding-bottom: 115px;
      height: 80vh;

      .ant-drawer-header {
        padding: 20px 20px 0 20px;

        .role {
          font-size: 24px;
          font-weight: 500;
          color: ${(props) => props.theme.white};
        }
      }

      .ant-drawer-body {
        .ant-menu-item {
          display: flex;
          padding: 0;
          .ant-menu-title-content {
            opacity: 0.7;
          }
        }
      }
    }

    &.mobile-menu {
      padding-bottom: 115px !important;
      height: 555px !important;

      .mobile-search-section-box {
        display: none;
      }

      @media only screen and (max-height: 950px) {
        height: 630px !important;
      }

      @media only screen and (max-height: 870px) {
        height: calc(100vh - 322px) !important;

        .mobile-search-section-box {
          display: block;
        }

        .search-section {
          position: fixed;
          top: 240px;
          left: 0;
        }
      }

      @media only screen and (max-height: 750px) {
        height: calc(100vh - 245px) !important;

        .mobile-search-section-box {
          display: block;
        }

        .search-section {
          top: 160px;
          width: calc(100vw - 30px);
        }
      }
    }

    .ant-menu-title-content {
      font-family: ${(props) => props.theme.fontText};
    }
  }

  .ant-drawer-body {
    padding-bottom: 0;
  }

  .ant-drawer-footer {
    padding: 8px 16px;
    border-top: 0;
    position: fixed;
    bottom: 100px;
    width: 100%;
    background-color: ${(props) => props.theme.white};
    padding-bottom: 20px;
  }
`;

export const MyProfileStyledDrawer = styled(AnteDrawer)`
  &.mobile-menu {
    margin-top: calc(100vh - 450px) !important;
  }
`;

export const MobileAuthStyledDrawer = styled(AnteDrawer)`
  box-shadow: ${(props) => props.theme.profileBoxShadow};
  font-family: ${(props) => props.theme.fontText};
  .ant-drawer-header {
    display: none;
  }
`;

export const StyledDeliveryDrawer = styled(AnteDrawer)`
  .ant-drawer-header {
    align-self: end;
    width: 100px;
    border-bottom: 0;
    position: absolute;

    svg {
      height: 30px;
      width: 30px;
    }
  }
`;

export const StyledCartDrawer = styled(AnteDrawer)`
  .farm-section {
    border-bottom: 1px solid ${(props) => props.theme.borderBottom};

    &:last-child {
      border-bottom: none;
    }

    .ant-card-bordered:last-child {
      border-bottom: none;
    }

    .ant-select {
      border: 1px solid ${(props) => props.theme.borderInput};
      border-radius: 4px;
    }
  }
  .ant-drawer-body {
    padding: 0 22px 0 22px;
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    .ant-drawer-title {
      font-size: 24px;
      font-family: ${(props) => props.theme.fontText};
      font-weight: 400;
      .ant-drawer-close {
        svg {
          height: 30px;
          width: 30px;
        }
      }
    }
  }

  .cart-drawer-saved-carts {
    padding-top: 16px;

    .ant-select {
      border: 1px solid ${(props) => props.theme.borderInput};
      border-radius: 4px;
    }
  }

  .ant-drawer-footer {
    border-top: 1px solid ${(props) => props.theme.borderBottom};
  }
`;

export const StyledNotificationDrawer = styled(AnteDrawer)`
  .ant-drawer-header-title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;

    .ant-drawer-close {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 22px;
      width: 22px;

      svg {
        width: 22px;
        height: 22px;
        color: ${(props) => props.theme.black} !important;
      }
    }

    .ant-drawer-title {
      text-decoration: none;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .dn-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dn-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .dn-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .dn-time {
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colorPadding};
  }

  .dn-body {
    display: grid;
    gap: 12px;
    margin-bottom: 8px;
    border: 1px solid ${({ theme }) => theme.colorBorder};
    border-radius: 5px;
    padding: 20px 20px;

    .ant-btn {
      width: fit-content;
      border-radius: 4px;
    }
  }

  .dn-text {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.descriptionText};
    white-space: pre-line;
  }

  .dn-changes {
    margin-top: 12px;
  }

  .dn-changes-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .dn-changes-section-title {
    font-weight: 600;
    font-size: 13px;
    margin: 8px 0 4px;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .dn-change-row {
    display: flex;
    gap: 8px;
    font-size: 13px;
    line-height: 20px;
    padding: 4px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
  }

  .dn-change-label {
    font-weight: 500;
    min-width: 160px;
    flex-shrink: 0;
  }

  .dn-change-values {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .dn-change-old {
    text-decoration: line-through;
    color: ${({ theme }) => theme.colorPadding};
  }

  .dn-change-arrow {
    color: ${({ theme }) => theme.colorPadding};
  }

  .dn-change-new {
    font-weight: 500;
  }

  .dn-change-list {
    list-style: disc;
    padding-left: 20px;
    margin: 4px 0;
    font-size: 13px;
    line-height: 20px;
  }

  .payload {
    margin-top: 16px;
  }

  .payload-title {
    font-weight: 600;
    margin-bottom: 6px;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  /* Footer */
  .drawer-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }

  .drawer-footer .ant-btn-primary:hover {
    filter: brightness(0.96);
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-body,
    .ant-drawer-header {
      padding: 16px;
    }

    .ant-drawer-footer {
      padding: 20px;
    }

    .dn-meta {
      .dn-time {
        font-size: 0.875rem;
      }

      .dn-title {
        font-size: 1rem;
      }

      .dn-text {
        font-size: 0.875rem;
      }
    }
  }
`;

export const StyledEditFarmDrawer = styled(AnteDrawer)`
  .ant-drawer-header {
    min-height: 113px;
  }

  .ant-drawer-body {
    padding-left: 0px;
    padding-bottom: 100px;
    .ant-tabs {
      padding-left: 20px;
    }
  }
`;

export const StyledEditCreateUserDrawer = styled(StyledDrawer)`
  .ant-checkbox-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

export const StyledAdminMobileFilterDrawerFooter = styled('div')``;

export const StyledAdminMobileFilterDrawer = styled(AnteDrawer)`
  .ant-drawer-header {
    padding: 15px 20px 15px 20px;

    .ant-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
      .ant-drawer-title {
        font-size: 1rem;
      }
    }
  }

  .ant-drawer-body {
    padding: 16px 16px 80px 16px;

    .styled-filter {
      padding: 0;
      margin: 0;
      border: none;

      .main-filter {
        padding: 0;
        border: none;
        background-color: transparent !important;

        .horizontal-form {
          .styled-category-selector {
            width: 100%;
          }

          .ant-select-arrow {
            img {
              width: 20px;
              height: auto;
            }
          }

          .category-selector-item {
            width: 100%;
            .ant-select {
              width: 100%;
              max-width: none;
            }
          }

          .button-section-container {
            position: absolute;
            bottom: 0;
            width: 100vw;
            height: fit-content;
            left: 0;
            display: flex;
            justify-content: flex-end;
            background-color: ${(props) => props.theme.filterBackground};
            z-index: 1;

            .button-section-wrapper {
              display: flex;
              padding: 16px;
              justify-content: flex-end;
              width: 100%;
              column-gap: 10px;
              .ant-btn {
                min-width: 140px;
                min-height: 40px;
              }

              .mobile-button {
                display: flex;
              }
            }
          }
          .ant-input-number {
            width: 100%;
          }

          .ant-form-item {
            width: 100%;

            .ant-picker {
              width: 100%;
            }

            .ant-select-selector {
              border-radius: 3px;
            }
          }

          .filter-submit-btn {
            display: none;
          }

          .advanced_filter {
            display: none;
          }
        }
      }

      .filter-container {
        display: none;
      }
    }
  }

  .ant-drawer-footer {
    display: none;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .ant-drawer-body {
      .styled-filter {
        .main-filter {
          .horizontal-form {
            .button-section-container {
              .button-section-wrapper {
                .ant-btn {
                  min-width: 100px;
                  min-height: 40px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const StyledBellNotificationsDrawer = styled(AnteDrawer)`
  .ant-drawer-header {
    min-height: 113px;
  }

  .ant-drawer-header-title {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;

    .ant-drawer-close {
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      width: auto;
      background: none !important;
    }

    .ant-drawer-title {
      max-width: 300px;
      text-decoration: none;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .bell-header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .bell-settings-btn {
    cursor: pointer;
    border: none;
    background: none;
    padding: 4px;
    display: flex;
    align-items: center;
    border-radius: 4px;

    &:hover {
      background: rgba(0, 0, 0, 0.06);
    }

    img {
      filter: brightness(0);
    }
  }

  .bell-close-icon {
    font-size: 22px;
    line-height: 1;
    color: ${(props) => props.theme.black};
    padding: 4px;
    border-radius: 4px;

    &:hover {
      background: rgba(0, 0, 0, 0.06);
    }
  }

  .list-loading {
    display: flex;
    justify-content: center;
    padding: 24px;
  }

  .empty {
    color: ${({ theme }) => theme.underTextColor};
  }

  .item {
    cursor: pointer;
  }

  .meta {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colorPadding};
    margin-bottom: 4px;
  }

  .meta .spacer {
    margin: 0 8px;
  }

  .meta .tag {
    margin-left: auto;
    display: flex;
    align-items: center;

    .ant-tag {
      margin-inline-end: 0;
    }
  }

  .title {
    font-weight: 700;
    color: ${({ theme }) => theme.contractTextTitleColor ?? theme.textColor};
  }
  .ant-drawer-footer {
    background: ${({ theme }) => theme.white};
    border: 0;
  }
  .drawer-footer {
    display: flex;
    justify-content: center;
  }

  .drawer-footer .ant-btn {
    font-weight: 700;
    min-width: 100%;
    border-radius: 1%;
    border: 1px solid ${({ theme }) => theme.colorPrimary};
    background: ${({ theme }) => theme.white};
    box-shadow: ${({ theme }) => theme.userCompanyBoxShadow};
  }
  .drawer-footer .ant-btn:hover {
    filter: brightness(0.95);
  }
`;

export const StyledRatingDrawerFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const StyledRatingDrawerActions = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
`;

export const StyledRatingWarning = styled.div`
  margin-bottom: 16px;
  color: ${(props) => props.theme.ratingStarColor};
`;

export const StyledRatingFormEdit = styled(AnteDrawer)`
  .ant-drawer-body {
    padding: 30px;
  }

  .rating-wrapper {
    display: flex;
    flex-direction: column;
  }

  .rating-comment {
    .ant-form-item {
      width: 100%;

      .ant-form-item-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .ant-form-item-label {
        margin: 10px 0;
      }

      .ant-form-item-control {
        width: 100%;
      }

      textarea.ant-input {
        width: 100%;
        min-height: 100px;
      }
    }
  }
`;

export const StyledDrawerViewListingApplication = styled(StyledDrawer)`
  .ant-drawer-header {
    min-height: unset !important;
  }

  .title label {
    font-weight: 500;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-drawer-header-title .ant-drawer-title {
      label {
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }

    .ant-drawer-footer > div {
      flex-direction: row;
      flex-wrap: wrap;
      overflow-x: visible;
      justify-content: flex-end;
      gap: 10px;

      > .ant-btn {
        padding-left: 5px;
        padding-right: 5px;
      }

      .left {
        flex-basis: 100%;
        margin-right: 0;
        text-align: start;
      }
    }
  }
`;

export const StyledCreateUpdateListingApplicationDrawer = styled(
  StyledDrawer
)``;

export const StyledShowListingContractChangesDrawer = styled(StyledDrawer)`
  .terms-content {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .free-form-description-label {
    margin-bottom: 10px;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-drawer-footer > div {
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: visible;
      justify-content: flex-end;
      gap: 10px;

      > .ant-btn {
        padding-left: 5px;
        padding-right: 5px;
      }

      .left {
        margin-right: auto;
      }
    }
  }
`;

export const StyledViewSelectedListingProductsDrawer = styled(StyledDrawer)`
  && {
    tbody tr:nth-child(2n) > td {
      background-color: transparent;
    }

    tbody tr.category-row > td {
      background-color: transparent;
    }

    tbody tr.supplier-row > td {
      background-color: ${({ theme }) => theme.tableSecondRowColor};
    }
  }

  .view-button {
    white-space: normal;
    word-wrap: break-word;
    padding: 5px 20px;
    height: auto;
    border-radius: 24px;
    color: ${({ theme }) => theme.colorButtonText};
  }

  .ant-drawer-header-title {
    .ant-drawer-title {
      margin-right: 40px;
      max-width: unset;
    }
  }

  @media (max-width: ${breakpoints.lg}px) {
    .title-container {
      flex-direction: column;
      align-items: flex-start !important;
      gap: 8px;
    }

    .total-label {
      justify-content: flex-start;
      padding: 0;
    }
  }

  .contract-checkbox {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.badgeBackground};

      &:after {
        border-color: ${({ theme }) => theme.white};
      }
    }
  }

  .contract-changes-button {
    color: ${({ theme }) => theme.red};
    text-decoration: underline;
    padding: 0;
    height: auto;
    border: none;
    box-shadow: none;

    &:hover {
      color: ${({ theme }) => theme.red};
      text-decoration: underline;
    }

    .text {
      text-decoration: underline;
    }
  }

  .product-name::before {
    content: '•';
    padding: 0 10px;
  }

  .status-tag.status {
    padding: 3px 10px;
    line-height: 18px;
    border-radius: 36px;
    font-size: 12px;
    color: ${({ theme }) => theme.white};
    border: none;
    margin: 0;
  }

  .status-tag.selected {
    background-color: ${({ theme }) => theme.statusHasOffers};
  }

  .status-tag.accepted {
    background-color: ${({ theme }) => theme.statusCompleted};
  }

  .status-tag.rejected {
    background-color: ${({ theme }) => theme.statusUnsuccessful};
  }

  .action-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .status-tag {
    text-transform: capitalize;
  }

  .ant-drawer-footer {
    border-top: 1px solid ${({ theme }) => theme.border};
    background-color: ${({ theme }) => theme.white};
  }

  .total-label {
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.textColor};
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;
    gap: 20px;
  }

  .table-container {
    flex: 1;
    min-width: 0;
  }

  .ant-table-row.ant-table-row-level-0 {
    .ant-table-cell {
      padding: 24px 26px !important;
    }
  }

  .ant-table-row.ant-table-row-level-1 {
    .ant-table-cell {
      background-color: ${({ theme }) => theme.tableSecondRowColor} !important;
      border-top: 1px solid ${({ theme }) => theme.borderBottom};
      padding: 16px 26px !important;
    }
  }

  .mobile-cards-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-product-card {
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .mobile-card-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;

    &.bordered {
      padding-bottom: 6px;
      border-bottom: 1px solid ${({ theme }) => theme.border};
    }
  }

  .mobile-card-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;

    &.end {
      align-items: flex-end;
      text-align: end;
    }
  }

  .mobile-card-label {
    color: ${({ theme }) => theme.stepInactiveColor};
  }

  .mobile-card-value {
    color: ${({ theme }) => theme.darkGrayishBlue};

    &.bold {
      font-weight: 600;
    }
  }

  .mobile-farm-offer {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px;
    background-color: ${({ theme }) => theme.filterBackground};

    > .bold {
      padding-bottom: 6px;
      border-bottom: 1px solid ${({ theme }) => theme.border};
    }
  }

  .mobile-view-btn {
    width: 100%;
    border: 1px solid ${({ theme }) => theme.darkGrayishBlue} !important;
    margin-top: 4px;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-drawer-footer > div {
      .footer-buttons {
        > .ant-btn {
          padding-left: 5px;
          padding-right: 5px;
        }
      }

      .left {
        flex-basis: 100%;
        margin-right: 0;
        text-align: start;
      }
    }
  }
`;

export const StyledMessageDetailDrawer = styled(StyledDrawer)`
  .message-header {
    margin-bottom: 24px;
  }

  .message-meta-row {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .message-meta-item {
    .meta-label {
      margin-bottom: 4px;
    }
  }

  .message-listing-wrapper {
    margin-top: 8px;
  }

  .message-body-wrapper {
    .body-label {
      margin-bottom: 8px;
    }
  }

  .message-body {
    font-size: 14px;
    line-height: 1.6;
    white-space: pre-wrap;
    margin-bottom: 24px;
    padding: 16px;
    background: ${(props) => props.theme.lightGray};
    border-radius: 8px;
  }

  .reply-section {
    margin-top: 24px;

    .reply-label {
      margin-bottom: 12px;
    }
  }

  .listing-link {
    display: inline-block;
    margin-top: 8px;
    font-size: 13px;
    color: ${(props) => props.theme.colorPrimary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledSendMessageDrawer = styled(StyledDrawer)`
  .info-text {
    font-size: 14px;
    color: ${(props) => props.theme.graytext};
    opacity: 0.8;
    margin-bottom: 10px;
  }

  .body-textarea {
    .ant-input {
      min-height: 210px;
    }
  }

  .selection-section {
    margin-bottom: 20px;

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-select {
      height: 40px;

      .ant-select-selection-wrap {
        height: 100%;
      }
    }
  }

  .ant-drawer-title {
    label {
      margin: 0;
    }
  }
`;

export const StyledChatDrawer = styled(StyledDrawer)`
  .ant-drawer-header {
    min-height: unset;
    padding: 20px 30px;
  }

  .ant-drawer-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${({ theme }) => theme.chatBgLight};
  }

  .ant-drawer-footer {
    padding: 0;
    border-top: 1px solid ${({ theme }) => theme.silverGray};
  }

  /* Header */
  .chat-header {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .chat-header-title {
      font-size: 16px;
      font-weight: 400;
      color: ${({ theme }) => theme.contractTextTitleColor};
      margin: 0;
    }

    .chat-header-brand {
      font-size: 14px;
      color: ${({ theme }) => theme.colorPadding};
    }

    .chat-header-tag {
      padding: 3px 10px;
      line-height: 18px;
      border-radius: 36px;
      font-size: 12px;
      color: ${({ theme }) => theme.white};
      background-color: ${({ theme }) => theme.statusCancelled};
      width: fit-content;
      border: none;
    }
  }

  /* Messages */
  .chat-messages-container {
    flex: 1;
    overflow-y: auto;
    padding: 20px 40px;
    display: flex;
    flex-direction: column-reverse;

    .chat-messages-inner {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .chat-messages-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .chat-messages-empty {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: ${({ theme }) => theme.colorPadding};
      font-size: 14px;
    }

    .chat-day-divider {
      margin: 5px 0;

      .ant-divider-inner-text {
        font-size: 12px;
        color: ${({ theme }) => theme.chatDayDividerColor};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .chat-messages-container {
      padding: 20px 16px;
    }
  }

  /* Message bubble */
  .chat-message {
    display: flex;
    flex-direction: column;
    max-width: 70%;

    .chat-message-sender-name {
      font-size: 12px;
      color: ${({ theme }) => theme.chatSenderLabelColor};
      margin-bottom: 4px;
    }

    .chat-message-bubble {
      padding: 8px 16px;
      border-radius: 16px;
      word-wrap: break-word;
      white-space: pre-wrap;

      .chat-message-content {
        font-size: 14px;
        line-height: 1.5;
        color: ${({ theme }) => theme.contractTextTitleColor};
      }

      .chat-message-footer {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 6px;

        .chat-message-time {
          font-size: 11px;
          color: ${({ theme }) => theme.colorPadding};
        }

        .chat-message-status {
          display: flex;
          align-items: center;
          font-size: 12px;

          .anticon,
          svg {
            color: ${({ theme }) => theme.chatCheckmarkGreen};
          }
        }
      }
    }

    &.left {
      align-self: flex-start;

      .chat-message-bubble {
        background-color: ${({ theme }) => theme.chatBubbleRecipient};
        border-top-left-radius: 0;

        .chat-message-content {
          align-self: flex-end;
        }
      }

      .chat-message-footer {
        justify-content: flex-start;
      }
    }

    &.right {
      align-self: flex-end;

      .chat-message-bubble {
        background-color: ${({ theme }) => theme.chatBubbleOwn};
        border-bottom-right-radius: 0;
      }

      .chat-message-footer {
        justify-content: flex-end;
      }

      .chat-message-sender-name {
        text-align: right;
      }
    }
  }

  /* Input area */
  .chat-input-area {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background-color: ${({ theme }) => theme.white};

    .chat-input-wrapper {
      flex: 1;

      .chat-input,
      .ant-input {
        width: 100%;
        padding: 10px 16px;
        border: 1px solid ${({ theme }) => theme.chatInputBorder};
        border-radius: 5px;
        outline: none;
        transition: border-color 0.2s;
        background-color: ${({ theme }) => theme.chatInputBackground};

        &:focus {
          border-color: ${({ theme }) => theme.colorPrimary};
        }

        &::placeholder {
          color: ${({ theme }) => theme.colorPadding};
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .chat-input-area {
      flex-direction: column;
      align-items: end;
      padding: 12px 15px;

      .chat-input-wrapper {
        width: 100%;
      }
    }
  }

  .chat-scroll-bottom {
    position: absolute;
    bottom: 80px;
    right: 24px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.chatScrollButtonBg};
    border: 1px solid ${({ theme }) => theme.chatScrollButtonBorder};
    box-shadow: 0 2px 8px ${({ theme }) => theme.chatScrollButtonShadow};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: ${({ theme }) => theme.colorPadding};

    &:hover {
      background-color: ${({ theme }) => theme.chatScrollButtonHover};
    }
  }
`;
